.Tabs {
  display: grid;
  grid: auto 1fr / auto;
}
